import { hideLoading, showLoading } from 'redux-store/reducers/loading-reducer';

import { API, get } from 'utils/api';
import { logError } from 'utils/log';

import type {
  CcmBrandPayment,
  Dispatch as CommonDispatch,
  Payout
} from 'types';
import {
  CcmCampaignPaymentCreatorPayoutsLoadedAction,
  CcmCampaignPaymentsBrandPaymentLoadedAction,
  CcmCampaignPaymentsDispatch,
  CcmCampaignPaymentsFlushAction,
  CcmCampaignPaymentsThunkDispatch
} from './types/CcmCampaignPaymentsRedux.type';

type Dispatch = CommonDispatch & CcmCampaignPaymentsDispatch & CcmCampaignPaymentsThunkDispatch;

const brandPaymetLoaded = (
  brandPayment: CcmBrandPayment
): CcmCampaignPaymentsBrandPaymentLoadedAction => ({
  type: 'ccm-campaign-payments/brand-loaded',
  payload: { brandPayment }
});

const creatorPayoutsLoaded = (
  creatorPayouts: Array<Payout>
): CcmCampaignPaymentCreatorPayoutsLoadedAction => ({
  type: 'ccm-campaign-payments/creator-payouts-loaded',
  payload: {
    creatorPayouts
  }
});

export const flush = (): CcmCampaignPaymentsFlushAction => ({
  type: 'ccm-campaign-payments/flush'
});

export const fetchPaymentInfo = (campaignId: number) => async (dispatch: Dispatch) => {
  const brandUrl = API.END_POINTS.CCM.getCampaignPayments(campaignId);
  const creatorsUrl = API.END_POINTS.PAYOUTS.handlePayoutsByCampaign(campaignId);
  const loaderKey = `${brandUrl}+${creatorsUrl}`;

  dispatch(showLoading(loaderKey));

  try {
    const [
      brendResponse,
      creatorsResponse
    ] = await Promise.all([get(brandUrl), get(creatorsUrl)]);

    dispatch(brandPaymetLoaded(brendResponse.data));
    dispatch(creatorPayoutsLoaded(creatorsResponse.data));
  } catch (error) {
    logError(error);
  } finally {
    dispatch(hideLoading(loaderKey));
  }
};
